<template>
  <article>
    <base-loading v-if="loading" />
    <div v-else>
      <h1 class="section-title text-center">{{ $t('privacy_policy_page.title') }}</h1>
      <div class="mt-4" v-html="getPrivacyPolicy"></div>
    </div>
  </article>
</template>

<script>
import store from '../../../store'
import { mapGetters } from 'vuex'
import BaseLoading from '../../base/BaseLoading'

export default {
  name: 'PrivacyPolicySection',
  components: { BaseLoading },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    fetchData () {
      store.dispatch('privacyPolicy/getPrivacyPolicy',
        { language: this.$i18n.locale })
        .then(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapGetters('privacyPolicy', ['getPrivacyPolicy'])
  },
  watch: {
    '$i18n.locale': {
      handler () {
        this.loading = true
        store.dispatch('projects/resetState').then(() => {
          this.fetchData()
        })
      }
    }
  },
  mounted () {
    if (this.getPrivacyPolicy.length === 0) this.fetchData()
    else this.loading = false
  }
}
</script>

<style>

.section-title {
  font-family: '8bit', sans-serif;
  margin: 20px 0;
}
.section-title:first-letter {
  @apply inline-block bg-black text-white p-5 mr-2 text-3xl font-bold;
}

.sub-section-title {
  font-family: '8bit', sans-serif;
  margin: 20px 0;
}
</style>
